import React from 'react';
import { Waves, MapPin, Users, Award, Lock, Mountain } from 'lucide-react';
import { propertyInfo } from '../mock';

export const Features = () => {
  // Map highlights to icons
  const iconMap = {
    "Covered wood-fired hot tub with ocean views": Waves,
    "Open views towards the North Atlantic Ocean": Mountain,
    "Self check-in with complete flexibility": Lock,
    "Residential area location (not separate glampsite)": Award,
    "Steps from Tullaghan Beach": MapPin,
    "Maximum 2-night stays for exclusive experience": Users
  };

  const features = propertyInfo.highlights.map(highlight => ({
    icon: iconMap[highlight] || Award,
    text: highlight
  }));

  return (
    <section className="py-12 sm:py-16 md:py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-light text-[#071936] text-center mb-8 sm:mb-10 md:mb-12">
            Why Stay Here
          </h2>

          {/* Mobile: 1 column, Tablet: 2 columns, Desktop: 3 columns */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5 md:gap-6">
            {features.map((feature) => {
              const IconComponent = feature.icon;
              return (
                <div
                  key={feature.text}
                  className="flex items-start gap-3 sm:gap-4 p-5 sm:p-6 bg-[#FBFAF7] rounded-lg hover:shadow-md transition-shadow duration-300"
                >
                  <div className="flex-shrink-0 mt-0.5">
                    <IconComponent className="text-[#2AA7A1]" size={22} strokeWidth={1.5} />
                  </div>
                  <p className="text-[#1F2937] font-normal text-sm sm:text-base leading-relaxed">{feature.text}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
